import { CdkDragDrop, moveItemInArray, transferArrayItem } from '@angular/cdk/drag-drop';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { Observable, Subscription, map, startWith } from 'rxjs';
import { AppState } from 'src/app/core/app.state';
import { ICatalog } from 'src/app/features/catalogs/models/catalogs.models';
import { FetchAllCatalogs } from 'src/app/features/catalogs/store/catalogs.actions';
import { SelectedCatalogsData } from '../../models/customers.models';
@Component({
  selector: 'app-inserting-catalogs',
  templateUrl: './inserting-catalogs.component.html',
  styleUrls: ['./inserting-catalogs.component.scss']
})
export class InsertingCatalogsComponent implements OnInit {
  @Input() selectedCatalogsO: ICatalog[] = [];
  @Input() currentCustomDiscount!: number;
  @Input() editCustom: boolean = false;
  @Input() updateCustom: boolean = false;
  selectedCatalogs: ICatalog[] = [];
  @Output() saveCatalogs = new EventEmitter<SelectedCatalogsData>();
  @Output() saveCustomeDiscount = new EventEmitter<number>();
  @Output() cancelCatalogs = new  EventEmitter<null>();
  showAlert: boolean = false;
  form!: FormGroup
  catalogs$: Observable<ICatalog[]> = this.store.select((state)=> state.catalogs.allCatalogs);
  private subscriptions: Subscription[] = [];
  catalogs: ICatalog[] = [];
  allCatalogs: ICatalog[] = [];
  search = new FormControl();
  constructor(
    private route: Router,
    private store: Store<AppState>,
    private fb: FormBuilder
  ) { }

  ngOnInit(): void {
    this.store.dispatch(FetchAllCatalogs());
    this.selectedCatalogs = [...this.selectedCatalogsO]
    const sub1 = this.catalogs$.subscribe(catalogs => {      
      this.allCatalogs = catalogs.map((catalog: ICatalog) => {
        return{
          ...catalog,
          additional_discount: this.currentCustomDiscount
        }
      });
      this.filterCatalogs()
    })

    this.form = this.fb.group({
      additional_discount: new FormControl(this.currentCustomDiscount ?? ''),
    });

    const sub2 = this.search.valueChanges.pipe(
      startWith(''),
      map(searchTerm => searchTerm.toLowerCase())
    ).subscribe(searchTerm => {
      this.filterCatalogs(searchTerm);
    })

    this.subscriptions.push(sub1, sub2)
  }

  filterCatalogs(searchTerm: string = ''): void {
    this.catalogs = this.allCatalogs.filter(catalog =>
      !this.selectedCatalogs.some(selectedCatalog => selectedCatalog.id === catalog.id) &&
      (catalog.name?.toLowerCase().includes(searchTerm))
    );
  }

  addCatalog(catalog: ICatalog) {
    this.selectedCatalogs.push(catalog);
    this.filterCatalogs(this.search.value ? this.search.value : '');
  }

  removeCatalog(catalog: ICatalog) {
    this.selectedCatalogs = this.selectedCatalogs.filter(l => l.id !== catalog.id);
    this.filterCatalogs(this.search.value ? this.search.value : '');
  }

  drop(event: CdkDragDrop<ICatalog[]>) {
    if (event.previousContainer === event.container) {
      moveItemInArray(event.container.data, event.previousIndex, event.currentIndex);
    } else {
      transferArrayItem(
        event.previousContainer.data,
        event.container.data,
        event.previousIndex,
        event.currentIndex,
      );
    }
    this.filterCatalogs(this.search.value ? this.search.value : '');
  }

  trackByFn(index: number, item: ICatalog) {
    return item.id;
  }

  overrideCounter(): number{
    const counter = this.selectedCatalogs.reduce((acc, catalog) => {
      if(catalog.additional_discount !== this.currentCustomDiscount){
        return acc + 1
      }
      return acc
    }, 0);  
    return counter;
  }

  onAdditionalDiscountChange(event: any, index: number){
    const input = event.target;
    const value = input.value < 0 ? 0 : input.value > 100 ? 100 : +input.value;
    input.value = value
    this.selectedCatalogs[index].additional_discount = value;
  }

  onCancel() {
    this.form.get('additional_discount')?.setValue(this.currentCustomDiscount)
    this.showAlert = false
  }

  onGeneralDiscountChange(event: any): boolean | void {
    if(this.updateCustom){
      const currentCustom = this.form.get('additional_discount')?.value
      if(this.currentCustomDiscount === currentCustom){
        this.showAlert = false
        return false
      }
      if(this.overrideCounter() > 0){
        this.showAlert = true
      } else {
        const input = event.target;
        const value = input.value < 0 ? 0 : input.value > 100 ? 100 : +input.value;
        input.value = value
        this.applyCustom(value);
      }
      return
    }
    const input = event.target;
    const value = input.value < 0 ? 0 : input.value > 100 ? 100 : +input.value;
    input.value = value
    this.applyCustom(value);
  }

  onSave(): boolean | void {
    const value = this.form.get('additional_discount')?.value;
    this.applyToGeneralCatalogs(value);
  }
  onApplyAll(){
    const value = this.form.get('additional_discount')?.value;
    this.applyCustom(value);
  }

  cancelChanges(){
    this.form.get('additional_discount')?.setValue(this.currentCustomDiscount);
    this.showAlert = false
  }

  private applyCustom(value: number){
    this.currentCustomDiscount = value;
    this.form.get('additional_discount')?.setValue(value);
    this.selectedCatalogs = this.selectedCatalogs.map((catalog: ICatalog) => {
      return {
        ...catalog,
        additional_discount: value,
      }
    })
    this.showAlert = false
  }

  private applyToGeneralCatalogs(value: number){
    if (value > 100) {
      this.currentCustomDiscount = 100;
      this.form.get('additional_discount')?.setValue(100);
      this.selectedCatalogs = this.selectedCatalogs.map((catalog: ICatalog) => {
        return {
          ...catalog,
          additional_discount: catalog.additional_discount === this.currentCustomDiscount ? 100 : catalog.additional_discount,
        }
      })
    } else {
      this.selectedCatalogs = this.selectedCatalogs.map((catalog: ICatalog) => {
        return {
          ...catalog,
          additional_discount: catalog.additional_discount === this.currentCustomDiscount ? value ? +value : undefined : catalog.additional_discount,
        }
      })
    }
    this.currentCustomDiscount = +this.form.get('additional_discount')?.value
    this.showAlert = false
  }

  save() {
    const additional_discount = this.form.get('additional_discount')?.value
    this.selectedCatalogsO = [...this.selectedCatalogs];
    this.saveCatalogs.emit({
      selectedCatalogs: this.selectedCatalogsO,
      customDiscount: additional_discount ? +additional_discount : undefined
    });
    this.saveCustomeDiscount.emit(additional_discount ? +additional_discount : undefined)

  }

  cancel(){
    this.cancelCatalogs.emit()
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach((sub => sub.unsubscribe()))
  }
}
